// src/utils/apiConfig.js
// ─────────────────────────────────────────────
// Central API configuration
// Change BACKEND_URL here for production deploy
// ─────────────────────────────────────────────

const apiConfig = {
  // ── Backend URL ──
  // Development:  http://localhost:4000
  // Production:   https://your-backend.railway.app
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL || "http://localhost:4000",
};

export default apiConfig;